<template>
  <header
    id="header"
    tabindex="-1">
    <transition name="fade">
      <div
        v-show="show_drawer"
        class="overlay"
        @click="hideDrawer"
      />
    </transition>

    <div
      v-if="!isInternationalUser || isApplePodcastsEnabled"
      ref="drawer"
      :class="show_drawer ? 'translate0' : 'translate-100'"
      class="drawer"
      tabindex="-1">
      <i
        v-button-event="{buttonName: 'Nav Close Drawer'}"
        :tabindex="show_drawer ? 0 : -1"
        class="el-icon-close closeBtn"
        data-test="drawer-close-btn"
        @keyup.enter="closeDrawer"
        @click="closeDrawer"/>
      <div class="logo">
        <router-link
          v-button-event="{buttonName: 'Nav Logo'}"
          :tabindex="show_drawer ? 0 : -1"
          :class="{'disabled' : disable_menu}"
          to="/"
          @click.native="closeDrawer">
          <img
            class="img-fluid"
            src="../assets/images/logo-new.svg"
            alt="Luminary Logo"
          >
        </router-link>
      </div>
      <div
        class="sub-menu"
        tabindex="-1">
        <router-link
          v-button-event="{buttonName: 'Nav Search'}"
          v-if="isLoggedIn"
          :tabindex="show_drawer ? 0 : -1"
          to="/listen/search"
          class="link has-active-state"
          aria-label="Search"
          @click.native="closeDrawer">
          <span class="menu-text">Search</span>
        </router-link>
        <router-link
          v-button-event="{buttonName: 'Nav My Shows'}"
          v-if="isLoggedIn"
          :tabindex="show_drawer ? 0 : -1"
          to="/listen/my-shows"
          class="link has-active-state"
          aria-label="My shows"
          @click.native="closeDrawer">
          <span class="menu-text">My Shows</span>
        </router-link>
        <router-link
          v-button-event="{buttonName: 'Nav Download'}"
          v-if="!isLoggedIn && !onListenRoute && !isInternationalUser"
          :tabindex="show_drawer ? 0 : -1"
          to="/"
          class="link"
          aria-label="Download"
          @click.native="downloadMobileApp">
          <span class="menu-text">Download</span>
        </router-link>
        <router-link
          v-button-event="{buttonName: 'Nav Originals'}"
          :tabindex="show_drawer ? 0 : -1"
          to="/shows"
          class="link"
          aria-label="Originals"
          @click.native="closeDrawer">
          <span class="menu-text">Originals</span>
        </router-link>
        <router-link
          v-button-event="{buttonName: 'Gift a Subscription'}"
          v-if="!isInternationalUser"
          :tabindex="show_drawer ? 0 : -1"
          class="link"
          to="/gift"
          aria-label="Gift a Subscription">
          Gift a Subscription
        </router-link>
        <a
          v-button-event="{buttonName: 'Shop Link'}"
          v-if="!isInternationalUser && isShopEnabled"
          class="link"
          href="https://shop.luminarypodcasts.com/"
          target="_blank"
        >
          Shop
        </a>
      </div>
      <div
        class="sub-menu"
        tabindex="-1">
        <router-link
          v-button-event="{buttonName: 'Nav My Account'}"
          v-if="isLoggedIn"
          :tabindex="show_drawer ? 0 : -1"
          to="/account/info"
          class="link"
          aria-label="My account"
          @click.native="closeDrawer">
          <span class="menu-text">My Account</span>
        </router-link>
        <a
          v-button-event="{buttonName: 'Nav Sign Out'}"
          v-if="isLoggedIn"
          :tabindex="show_drawer ? 0 : -1"
          class="link"
          aria-label="Sign out"
          @click="logout">
          <span class="menu-text">Sign out</span>
        </a>
        <router-link
          v-button-event="{buttonName: 'Nav Sign Up'}"
          v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser"
          :tabindex="show_drawer ? 0 : -1"
          :to="{path: '/signup', query: $route.query}"
          class="link"
          aria-label="Sign up"
          @click.native="closeDrawer">
          <span class="menu-text">Sign up</span>
        </router-link>
        <router-link
          v-button-event="{buttonName: 'Nav Log In'}"
          v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser"
          :tabindex="show_drawer ? 0 : -1"
          to="/signin"
          class="link"
          aria-label="Log in"
          @click.native="closeDrawer">
          <span class="menu-text">Log in</span>
        </router-link>
      </div>
    </div>

    <div
      class="app-navbar"
      data-test="navbar">
      <div class="container">
        <div
          v-button-event="{buttonName: 'Nav Hamburger Icon'}"
          v-if="!isInternationalUser || isApplePodcastsEnabled"
          tabindex="0"
          class="hamburger-menu"
          @keyup.enter="showDrawer"
          @click="showDrawer">
          <img src="../assets/images/HamburgerWhite.svg">
        </div>
        <div class="logo">
          <router-link
            v-button-event="{buttonName: 'Nav Logo'}"
            :class="{'disabled' : disable_menu}"
            :to="isInternationalUser && !isApplePodcastsEnabled ? '/international' : '/'">
            <img
              class="img-fluid"
              src="../assets/images/logo-new.svg"
              alt="Luminary Logo">
          </router-link>
        </div>
        <div
          v-if="!isInternationalUser || isApplePodcastsEnabled"
          class="right-menu">
          <el-row
            type="flex"
            align="middle"
            justify="end">
            <div
              class="link-menu un-auth">
              <router-link
                v-button-event="{buttonName: 'Nav Originals'}"
                class="link"
                aria-label="Originals"
                to="/shows">
                Originals
              </router-link>
              <router-link
                v-button-event="{buttonName: 'Nav Search'}"
                v-if="isLoggedIn"
                :class="`${inSearchSection ? ' router-link-exact-active active ' : ''}`"
                class="link"
                aria-label="Search"
                to="/listen/search">
                Search
              </router-link>
              <router-link
                v-button-event="{buttonName: 'Nav My Shows'}"
                v-if="isLoggedIn"
                :class="`${isUserLibrarySection ? ' router-link-exact-active active ' : ''}`"
                class="link"
                aria-label="My shows"
                to="/listen/my-shows">
                My Shows
              </router-link>
              <a
                v-button-event="{buttonName: 'Shop Link'}"
                v-if="isLoggedIn && isShopEnabled"
                class="link"
                href="https://shop.luminarypodcasts.com/"
                target="_blank"
              >
                Shop
              </a>
            </div>
            <div class="link-menu auth">
              <router-link
                v-button-event="{buttonName: 'Gift a Subscription'}"
                v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser"
                class="link"
                to="/gift"
                aria-label="Gift a Subscription">
                Gift a Subscription
              </router-link>
              <router-link
                v-button-event="{buttonName: 'Nav Sign Up'}"
                v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser"
                class="link"
                to="/signup"
                aria-label="Sign up"
                data-test="btn-signupheader">
                Sign up
              </router-link>
              <router-link
                v-button-event="{buttonName: 'Nav Log In'}"
                v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser"
                class="link"
                to="/signin"
                data-test="btn-loginheader">
                Log In
              </router-link>
              <a
                v-button-event="{buttonName: 'Shop Link'}"
                v-if="!isLoggedIn && !hasAlexaQuery && !isInternationalUser && isShopEnabled"
                class="link"
                href="https://shop.luminarypodcasts.com/"
                target="_blank"
              >
                Shop
              </a>
              <el-dropdown
                v-if="isLoggedIn"
                :trigger="isTouchDevice ? 'click' : 'hover'"
                class="user-avatar-menu-desktop">
                <span
                  class="el-dropdown-link"
                  aria-label="User Avatar Menu">
                  <svg v-if="user.is_subscribed" svg-inline="" class="profile-pic" data-test="icon-user" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_premium_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_premium_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-91.000000, -797.000000) translate(91.000000, 796.992335)"><mask id="ic_authuser_premium_svg__b" fill="white"><use xlink:href="#ic_authuser_premium_svg__a"/></mask><g mask="url(#ic_authuser_premium_svg__b)"><g><mask id="ic_authuser_premium_svg__d" fill="white"><use xlink:href="#ic_authuser_premium_svg__c"/></mask><g fill="#FFE500" mask="url(#ic_authuser_premium_svg__d)"><rect width="24" height="24"/></g></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_premium_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
                  <svg v-else="" svg-inline="" class="profile-pic" data-test="icon-user" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><mask id="ic_authuser_gray_svg__a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse"><path fill="white" fill-rule="evenodd" d="M16 0C7.16401 0 0 7.164 0 16C0 24.837 7.16401 32 16 32C24.836 32 31.999 24.837 31.999 16C31.999 7.164 24.836 0 16 0Z" clip-rule="evenodd"/></mask><g mask="url(#ic_authuser_gray_svg__a)"><mask id="ic_authuser_gray_svg__b" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse"><path fill="white" fill-rule="evenodd" d="M0 0H31.9996V32H0V0Z" clip-rule="evenodd"/></mask><g mask="url(#ic_authuser_gray_svg__b)"><rect width="31.9996" height="32" fill="#BBBBBB"/></g><path fill="#777774" fill-rule="evenodd" d="M21.1219 14.2079C21.1219 17.0369 18.8289 19.3299 15.9999 19.3299C13.1719 19.3299 10.8779 17.0369 10.8779 14.2079C10.8779 11.3789 13.1719 9.08594 15.9999 9.08594C18.8289 9.08594 21.1219 11.3789 21.1219 14.2079Z" clip-rule="evenodd"/><path stroke="#111111" stroke-width="1.5" d="M7.63184 16.3408V13.2968C7.63184 9.36281 10.5978 4.88281 16.0468 4.88281C22.2189 4.88281 24.4619 9.36281 24.4619 13.2968V16.3408"/><path fill="#111111" fill-rule="evenodd" d="M22.7302 19.6939C25.6672 19.2889 27.8932 18.3509 27.8932 14.7809C27.8932 10.9549 25.6382 11.3449 22.6992 10.9609L22.7302 19.6939Z" clip-rule="evenodd"/><path fill="#111111" fill-rule="evenodd" d="M9.50971 9.9043C6.57271 10.3093 4.3387 12.3553 4.3467 14.8173C4.3547 17.2793 6.60171 19.3093 9.54071 19.6943L9.50971 9.9043Z" clip-rule="evenodd"/><path fill="#777774" fill-rule="evenodd" d="M27.6898 33.0001C26.7948 25.8581 22.1778 20.4121 16.6007 20.4121C11.0227 20.4121 6.40574 25.8581 5.51074 33.0001H27.6898Z" clip-rule="evenodd"/></g></svg>
                </span>
                <el-dropdown-menu
                  slot="dropdown"
                  :disabled="disable_menu"
                  :append-to-body="true">
                  <el-dropdown-item
                    data-test="option-menu">
                    <span v-if="user && user.email"> Hi,</span>
                    <span class="capitalize"> {{ user && user.email ? user.email.substring(0, user.email.indexOf('@')) : 'User Name' }} </span>
                    <span class="arrow"><i class="el-icon-arrow-up" /></span>
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-button-event="{buttonName: 'Nav My Account'}"
                    data-test="option-menu"
                    @click.native="navigateToMyAccount">
                    My Account
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-button-event="{buttonName: 'Gift a Subscription'}"
                    @click.native="navigateToGift">
                    Gift a Subscription
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-button-event="{buttonName: 'Nav Sign Out'}"
                    data-test="option-menu"
                    @click.native="logout">
                    Sign Out
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-row>
        </div>
        <el-dropdown
          v-if="isLoggedIn && (!isInternationalUser || isApplePodcastsEnabled)"
          trigger="click"
          class="user-avatar-menu">
          <span
            class="el-dropdown-link"
            aria-label="User Avatar Menu">
            <svg v-if="user.is_subscribed" svg-inline="" class="profile-pic" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_authuser_premium_svg__a" d="M12,0 C5.373,0 0,5.373 0,12 L0,12 C0,18.62775 5.373,24 12,24 L12,24 C18.627,24 23.99925,18.62775 23.99925,12 L23.99925,12 C23.99925,5.373 18.627,0 12,0 Z"/><polygon id="ic_authuser_premium_svg__c" points="0 0 23.9997 0 23.9997 24 0 24"/></defs><g fill="none" fill-rule="evenodd"><g><g><g transform="translate(-91.000000, -797.000000) translate(91.000000, 796.992335)"><mask id="ic_authuser_premium_svg__b" fill="white"><use xlink:href="#ic_authuser_premium_svg__a"/></mask><g mask="url(#ic_authuser_premium_svg__b)"><g><mask id="ic_authuser_premium_svg__d" fill="white"><use xlink:href="#ic_authuser_premium_svg__c"/></mask><g fill="#FFE500" mask="url(#ic_authuser_premium_svg__d)"><rect width="24" height="24"/></g></g><path fill="#777774" d="M15.841275,10.655625 C15.841275,12.777375 14.121525,14.497125 11.999775,14.497125 C9.878775,14.497125 8.158275,12.777375 8.158275,10.655625 C8.158275,8.533875 9.878775,6.814125 11.999775,6.814125 C14.121525,6.814125 15.841275,8.533875 15.841275,10.655625"/><path stroke="#111111" stroke-width="1.5" d="M5.723925,12.2556 L5.723925,9.9726 C5.723925,7.0221 7.948425,3.6621 12.035175,3.6621 C16.664175,3.6621 18.346425,7.0221 18.346425,9.9726 L18.346425,12.2556"/><path fill="#111111" d="M17.047575,14.770725 C19.250325,14.466975 20.919825,13.763475 20.919825,11.085975 C20.919825,8.216475 19.228575,8.508975 17.024325,8.220975 L17.047575,14.770725 Z"/><path fill="#111111" d="M7.13235,7.428225 C4.9296,7.731975 3.2541,9.266475 3.2601,11.112975 C3.2661,12.959475 4.95135,14.481975 7.1556,14.770725 L7.13235,7.428225 Z"/></g><g fill="#777774" mask="url(#ic_authuser_premium_svg__b)"><g><path d="M16.7675,9.75 C16.09625,4.3935 12.6335,0.309 8.45075,0.309 C4.26725,0.309 0.8045,4.3935 0.13325,9.75 L16.7675,9.75 Z" transform="translate(4.000000, 15.000000)"/></g></g></g></g></g></g></svg>
            <svg v-else="" svg-inline="" class="profile-pic" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32"><mask id="ic_authuser_gray_svg__a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse"><path fill="white" fill-rule="evenodd" d="M16 0C7.16401 0 0 7.164 0 16C0 24.837 7.16401 32 16 32C24.836 32 31.999 24.837 31.999 16C31.999 7.164 24.836 0 16 0Z" clip-rule="evenodd"/></mask><g mask="url(#ic_authuser_gray_svg__a)"><mask id="ic_authuser_gray_svg__b" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse"><path fill="white" fill-rule="evenodd" d="M0 0H31.9996V32H0V0Z" clip-rule="evenodd"/></mask><g mask="url(#ic_authuser_gray_svg__b)"><rect width="31.9996" height="32" fill="#BBBBBB"/></g><path fill="#777774" fill-rule="evenodd" d="M21.1219 14.2079C21.1219 17.0369 18.8289 19.3299 15.9999 19.3299C13.1719 19.3299 10.8779 17.0369 10.8779 14.2079C10.8779 11.3789 13.1719 9.08594 15.9999 9.08594C18.8289 9.08594 21.1219 11.3789 21.1219 14.2079Z" clip-rule="evenodd"/><path stroke="#111111" stroke-width="1.5" d="M7.63184 16.3408V13.2968C7.63184 9.36281 10.5978 4.88281 16.0468 4.88281C22.2189 4.88281 24.4619 9.36281 24.4619 13.2968V16.3408"/><path fill="#111111" fill-rule="evenodd" d="M22.7302 19.6939C25.6672 19.2889 27.8932 18.3509 27.8932 14.7809C27.8932 10.9549 25.6382 11.3449 22.6992 10.9609L22.7302 19.6939Z" clip-rule="evenodd"/><path fill="#111111" fill-rule="evenodd" d="M9.50971 9.9043C6.57271 10.3093 4.3387 12.3553 4.3467 14.8173C4.3547 17.2793 6.60171 19.3093 9.54071 19.6943L9.50971 9.9043Z" clip-rule="evenodd"/><path fill="#777774" fill-rule="evenodd" d="M27.6898 33.0001C26.7948 25.8581 22.1778 20.4121 16.6007 20.4121C11.0227 20.4121 6.40574 25.8581 5.51074 33.0001H27.6898Z" clip-rule="evenodd"/></g></svg>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            :disabled="disable_menu"
            :append-to-body="false">
            <el-dropdown-item>
              <span v-if="user && user.email"> Hi,</span>
              <span class="capitalize"> {{ user && user.email ? user.email.substring(0, user.email.indexOf('@')) : 'User Name' }} </span>
              <span class="arrow"><i class="el-icon-arrow-up" /></span>
            </el-dropdown-item>
            <el-dropdown-item
              v-button-event="{buttonName: 'Nav My Account'}"
              @click.native="navigateToMyAccount">
              My Account
            </el-dropdown-item>
            <el-dropdown-item
              v-button-event="{buttonName: 'Gift a Subscription'}"
              @click.native="navigateToGift">
              Gift a Subscription
            </el-dropdown-item>
            <el-dropdown-item
              v-button-event="{buttonName: 'Nav Sign Out'}"
              @click.native="logout">
              Sign Out
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import * as log from 'loglevel';
import User from '../services/User';

export default {
  name: 'Navbar',
  data() {
    return {
      userProvider: new User(),
      hide_menu: false,
      defaultTab: '',
      hidden: false,
      disabled_paths: ['/user-info', '/user-categories', '/user-shows', '/complete'],
      active_tabs: {
        '/listen/my-shows': { activeTab: '3' }, '/listen/bookmarks': { activeTab: '3' }, '/listen/my-shows/list': { activeTab: '3' }, '/listen/search': { activeTab: '2' }, '/listen': { activeTab: '1' }, '': { activeTab: '1' },
      },
      current_width: window.innerWidth,
      show_drawer: false,
    };
  },
  computed: {
    isShopEnabled() {
      return this.$store.getters.featureFlags.shop_links;
    },
    isTouchDevice() {
      return window.isTouch;
    },
    isLoggedIn() {
      const { user } = this.$store.getters;
      const { token } = this.$store.getters;

      const loggedIn = token && token.length && user && user.uuid;
      return loggedIn;
    },
    onListenRoute() {
      return this.$route.path.includes('/listen') || this.$route.path.includes('/premium');
    },
    showHomeAndSearchLinks() {
      if (this.isInternationalUser && !this.isApplePodcastsEnabled) {
        return false;
      }

      const hideOnPage = path => ['/', '/shows', '/international'].includes(path);
      return this.isLoggedIn || !hideOnPage(this.$route.path);
    },
    isPremiumUser() {
      const { user } = this.$store.getters;

      return user && user.uuid && user.is_subscribed;
    },
    user() {
      return this.$store.getters.user;
    },
    disable_menu() {
      // return this.disabled_paths.includes(this.$route.path);
      return false;
    },
    hasAlexaQuery() {
      return !!this.$route.query.alexa;
    },
    isUserLibrarySection() {
      const { path } = this.$route;
      if (path === '/listen/my-shows') {
        return true;
      }
      if (path === '/listen/bookmarks') {
        return true;
      }
      if (path === '/listen/my-shows/list') {
        return true;
      }
      return false;
    },
    inSearchSection() {
      const { path } = this.$route;
      if (path === '/listen/search') {
        return true;
      }
      if (path.indexOf('/category') > -1) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route(to, from) {
      this.setUserRedirectPath(to, from);
      this.hidePremiumButton();
      this.setDefaultTab();
      this.hidePlayer();
    },
    user() {
      this.updateAppStyle();
    },
    show_drawer() {
      // Hide scrolling when overlay is shown.
      if (this.show_drawer) this.disableVerticalScroll();
      else this.enableVerticalScroll();
    },
  },
  mounted() {
    this.setDefaultTab();
    this.hidePremiumButton();
    this.updateAppStyle();
    window.onresize = () => {
      this.updateAppStyle();
    };
  },
  methods: {
    downloadMobileApp() {
      let downloadAppLink = window.location.hostname;
      if (this.detectMobileOs === 'android') {
        downloadAppLink = process.env.LUMINARY_BRANCH_IO_PLAY_STORE_LINK || window.location.hostname || '';
      } else if (this.detectMobileOs === 'ios') {
        downloadAppLink = process.env.LUMINARY_BRANCH_IO_APP_STORE_LINK || window.location.hostname || '';
      }
      window.open(downloadAppLink);

      this.closeDrawer();
    },
    hidePlayer() {
      if (this.$route.path.includes('signin') || this.$route.path.includes('signup') || this.$route.path.includes('forgotPassword') || this.disabled_paths.includes(this.$route.path)) window.eventBus.$emit('hide-player');
    },
    hideDrawer() {
      this.show_drawer = false;
    },
    setUserRedirectPath(to, from) {
      // Reset redirect path, if user navigates from signup to any other page than the next onboarding one.
      if ((from.path.includes('/signup') || from.path.includes('/sign-in')) && !to.path.includes('/user-info')) {
        this.$store.dispatch('setRedirectPath', null);
      }
      // Set user redirect path if they navigate from either EDP or SDP to signup page.
      if ((from.path.includes('/listen')) && (to.path.includes('/signup') || to.path.includes('/signin'))) {
        log.info('Redirect Path Set', from.path);
        this.$store.dispatch('setRedirectPath', from.path);
      }
    },
    redirect(link) {
      this.show_drawer = false;
      this.$router.push(link);
    },
    closeDrawer() {
      this.show_drawer = false;
    },
    showDrawer() {
      this.show_drawer = true;
      this.$refs.drawer.focus();
    },
    setDefaultTab() {
      this.defaultTab = (this.active_tabs[this.$route.path] && this.active_tabs[this.$route.path].activeTab) || '4';
    },
    gotoAccount() {
      if (this.disable_menu) return;
      this.$router.push('/account/info');
    },
    logout() {
      this.show_drawer = false;

      if (this.disable_menu) return;
      window.eventBus.$emit('hide-player');
      this.userProvider.logout()
        .then(() => {
          this.$router.push('/');
        });
      this.$analytics.track('logout');
      this.$analytics.trackLogin('logout');
      this.$store.dispatch('setRedirectPath', null);
      setTimeout(() => {
        this.showSuccessMsg('You have been logged out!');
      }, 1000);
      // this.removeMarginFromFooter();
    },
    navigateToMyAccount() {
      this.$router.push('/account/info');
    },
    navigateToGift() {
      this.$router.push('/gift');
    },
    hidePremiumButton() {
      this.hidden = this.$route.path.includes('signin') || this.$route.path.includes('signup');
    },
    disableNavigation() {
      return this.disabled_paths.includes(this.$route.path);
    },
    updateAppStyle() {
      const app = document.getElementById('app');
      if (app && !this.isLoggedIn && !this.isMarketingPage && window.screen.width <= 768) {
        if (app.classList.value.indexOf('auth-footer-visible') < 0) {
          app.classList.add('auth-footer-visible');
        }
      } else {
        app.classList.remove('auth-footer-visible');
      }
    },
    removeMarginFromFooter() {
      const app = document.getElementById('app');
      const body = document.querySelector('body');
      if (!app) return;
      app.classList.remove('audio-player-visible');
      body.classList.remove('audio-player-visible');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "../assets/scss/variables.scss";

#header {
  outline: none;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.7);
  transition: .2s all ease-in-out;
  z-index: 9998;
}

.logo {
  line-height: 0;
}

.drawer {
  width: 277px;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  transform: translateX(-100%);
  background-color: $dark-background;
  color: $brand;
  transition: 0.4s all ease-in-out;
  z-index: 9999;
  &:focus {
    outline: none;
  }

  .logo {
    padding-left: 20px;
    margin-bottom: 30px;

    img {
      width: 100px;
    }
  }

  .sub-menu {
    position: relative;

    .link {
      padding: 10px 0 10px 20px;

      display: flex;
      align-items: center;

      color: white;

      > .icon {
        margin-right: 5px;
      }

      > span {
        margin-top: 2px;
      }

      &:not(:last-child) {
        margin-bottom: 10px;
      }

      &.has-active-state {
        &.router-link-exact-active {
          > span {
            position: relative;
            &::after {
              content: '';

              height: 1px;
              width: calc(100% + 29px);

              position: absolute;
              top: calc(100% + 2px);
              left: -29px;

              background-color: $black;
            }
          }
        }
      }
      &:hover, :active, :visited, :focus {
        color: $blue;
        background-color: $dark-background;
      }
    }
    &:not(:last-child) {
      padding-bottom: 20px;
      margin-bottom: 15px;

      &::after {
        content: '';
        position: absolute;

        top: 100%;
        left: 20px;

        width: 257px;
        height: 1px;

        background-color: #343B4A;
      }
    }
  }

  .closeBtn {
    cursor: pointer;
    display: inline-block;
    margin: 20px 0 32px 16px;
    color: #CCCCCC;
    font-size: 22px;
    i {
      font-size: 22px;
    }
  }
}

.translate0 {
  transform: translateX(0);
}

.translate-100 {
  transform: translateX(-100%);
}

.disabled {
  pointer-events: none !important;
}

.el-dropdown-menu {
  min-width: 157px;
  height: 159px;
  border-radius: 10px;
  border-color: #ffffff;
  background-color: #ffffff;
  color: $black;

  .el-dropdown-menu__item{
    font-size: 14px;
    line-height: 35px;
    margin: 16px 0px;
    color: inherit;

    .arrow{
      float: right;
      font-size: 16px;
      color: inherit;
      margin-left:10px;
      font-weight: 700 !important;
    }
  }
  .el-dropdown-menu__item:hover{
    color: #ffffff !important;
    background-color: $blue !important;
    .arrow {
      color: inherit;
    }
  }
  .el-dropdown-menu__item a{
    color: inherit;
  }
}

.app-navbar {
  z-index: 998;
  height: 72px;
  min-height: 72px;
  padding: 6px 0;
  border-bottom: 1px solid $dark-border;
  box-sizing: border-box;
  position: relative;

  display: flex;
  align-items: center;
  background-color: $dark-background;
  color: $brand;
  .el-menu-item {
    color: inherit;
    padding:0 0.25rem;
    line-height: 24px !important;
    height: auto;
    margin: 0 0 0 48px;
    padding: 0;
    // opacity: 0.7;
    * { vertical-align: baseline;  }

    img {
      width: 24px;
      margin-bottom: -5px;
    }

    .menu-text {
      font-size: 16px;
      font-family: $clear-sans;
    }

    &.is-active {
      opacity: 1;
      color: inherit;
      border-color: $black;
      border-width: 1px;
    }

    &:hover {
      opacity: 1;
    }

    @media (max-width: 1024px) {
      margin: 0 0 0 24px;
    }
  }

  .el-menu-item:first-child {
    margin-left: 0px;
  }

  .profile-pic {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin-top: 4px;
  }

  .el-menu--horizontal {
    border-bottom: none !important;
    background-color: inherit;
  }

  .f-r .is-active {
    border-bottom: 0 !important;
  }

  .user-avatar-menu {
    display: none;
    position: absolute;

    right: 0;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 768px) {
      display: block;
    }
  }

  .user-avatar-menu, .user-avatar-menu-desktop {
    .el-dropdown-menu {
      transform: translateX(-100%);
      left: 45px !important;
      width: 200px !important;

      &__item {
        width: 100% !important;
        text-overflow: ellipsis;
        overflow: hidden;
        box-sizing: border-box;
        white-space: nowrap;

        &:first-child {
          position: relative;
          width: 100% !important;
          padding-right: 30px !important;

          span:last-child {
            position: absolute;
            top: 50%;
            right: 5px;

            transform: translateY(-50%);
            float: none;
          }
        }
      }
    }
  }

  .user-dropdown {
    .el-submenu__title {
      border-bottom: 2px solid transparent !important;
    }

    .account_img {
      border-radius: 50%;
      width: 2.5rem;
      height: 2.5rem;
    }

    .el-icon-arrow-down {
      display: none;
    }
  }

  .el-button {
    height: 40px;
  }

  .tabs-menu {
    margin-left: 45px;

    @media (max-width: 1024px) {
      margin-left: 30px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  > .container {
    display: flex;
    align-items: center;
    position: relative;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  .logo img {
    width: 100px;
    height: 24px;

    @media (max-width: 768px) {
      width: 85px;
      height: 20px;
    }

    @media (max-width: 567px) {
      width: 123px;
      height: 30px;
    }
  }

  .hamburger-menu {
    display: none;
    line-height: 0;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);

    @media (max-width: 567px) {
      display: block;
    }
  }

  .right-menu {
    margin-left: auto;

    @media (max-width: 567px) {
      position: absolute;
      right: 0;

      .un-auth {
        display: none;
      }
    }

    @media (max-width: 567px) {
      display: none;
    }
  }

  .link-menu {
    .link {
      color: $white;
      position: relative;
      opacity: 1;
      &:not(:last-child) {
        margin-right: 50px;
        @media (max-width: $xs) {
          margin-right: 36px;
        }
      }

      &::after {
        content: '';

        position: absolute;

        top: 100%;
        left: 0;

        background-color: $brand;
        opacity: 0;

        transition: opacity 250ms ease;

        height: 0px;
        width: 100%;
      }

      &:hover {
        opacity: 1;
        color: $blue;
        text-decoration: underline;
        &::after {
          opacity: 1;
        }
      }

      &.router-link-exact-active {
        opacity: 0.6;
      }
    }

    &:not(:last-child) {
      margin-right: 50px;
      position: relative;
      @media (max-width: $xs) {
        margin-right: 36px;
      }
    }

    @media (max-width: 767px) {
      &:first-child {
        display: none;
      }
    }
  }
}

</style>
